import React, { Component } from 'react';
import { Switch, message } from 'antd';
import $ from '../../../common/AjaxRequest';
import API_URL from '../../../common/url';
import SideNav from '../SideNav';

class Information extends Component {
    state = {
        mailFlag: 0,
    }

    componentDidMount() {
        this.loadEmailSet();
    }

    loadEmailSet = () => {
        const options = {
            method: 'POST',
            url: API_URL.config.queryUserEmail,
            data: {},
            dataType: 'json',
            doneResult: res => {
                const { data: { mailFlag } } = res;
                this.setState({ mailFlag });
            }
        };
        $.sendRequest(options);
    }

    toggle = (checked) => {
        const options = {
            method: 'POST',
            url: API_URL.config.userIsSendEmail,
            data: {
                mailFlag: checked ? 1 : 0,
            },
            dataType: 'json',
            doneResult: res => {
                message.success(res.success);
                const mailFlag = checked ? 1 : 0;
                this.setState({ mailFlag });
            }
        };
        $.sendRequest(options);
    }

    render() {
        const { mailFlag } = this.state;
        return (
            <div className="content">
                <SideNav selectKey='setting' />
                <div className="main" style={{ minHeight: 500, paddingLeft: 240 }}>
                    <div style={{ width: '50%', marginTop: 100, overflow: 'hidden' }}>
                        <div style={{ float: 'left', fontSize: '14px', fontWeight: 600 }}>邮件通知方式</div>
                        <Switch style={{ float: 'right' }} checkedChildren="开" unCheckedChildren="关" onChange={this.toggle} checked={mailFlag == 1} />
                    </div>
                    <p style={{ marginTop: 10 }}>开启邮件通知方式后，系统消息将以邮件形式通知</p>
                </div>
            </div>
        )
    }
}

export default Information;


// WEBPACK FOOTER //
// ./src/components/personal/setting/index.js